import type { Identifier } from "ra-core";

/** The "Marketing" module: Litus' own content, channels and results. */
export const MARKETING_BASE = "/marketing";

export type MarketingTab =
  "summary" | "calendar" | "pipeline" | "plans" | "channels" | "analytics";

/** Section order; the summary is the module index. */
export const MARKETING_TABS: readonly { id: MarketingTab; path: string }[] = [
  { id: "summary", path: "" },
  { id: "calendar", path: "calendario" },
  { id: "pipeline", path: "pipeline" },
  { id: "plans", path: "planes" },
  { id: "channels", path: "canales" },
  { id: "analytics", path: "analiticas" },
];

export const marketingTabPath = (tab: MarketingTab): string => {
  const path = MARKETING_TABS.find((entry) => entry.id === tab)!.path;
  return path ? `${MARKETING_BASE}/${path}` : MARKETING_BASE;
};

/** Section of a /marketing/... path (a plan's page belongs to Planes). */
export const marketingTabOfPath = (pathname: string): MarketingTab => {
  const segment = pathname.slice(MARKETING_BASE.length + 1).split("/")[0];
  return (
    MARKETING_TABS.find((tab) => tab.path && tab.path === segment)?.id ??
    "summary"
  );
};

export const planPath = (id: Identifier): string =>
  `${marketingTabPath("plans")}/${encodeURIComponent(String(id))}`;

/** Query parameter of the piece sheet, open on top of any section. */
export const PIECE_PARAM = "pieza";

/** The current path with the piece sheet of `id` open. */
export const withPiece = (search: string, id: Identifier | null): string => {
  const params = new URLSearchParams(search);
  if (id == null) params.delete(PIECE_PARAM);
  else params.set(PIECE_PARAM, String(id));
  const query = params.toString();
  return query ? `?${query}` : "";
};
